// extracted by mini-css-extract-plugin
module.exports = {"quote":"Styles_quote__UxsSL"};